export function minifyGraphQL(query: string) {
  return query
    .replace(/\s+/g, ' ')
    .replace(/\s*([{}])\s*/g, '$1')
    .trim();
}
